import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from './toast.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorService {
    constructor(private translate: TranslateService, private toastService: ToastService) {
    }

    handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            this.toastService.error('An error occurred');
            console.error('An error occurred:', error.error.message);
        } else {
            if (error.status == 401) {
                const msg = this.translate.instant('errors.sessionExpired');
                this.toastService.error(msg, '', 5000);
                window.location.href = '/';
            }
            else {
                console.error(`Backend returned code ${error.status}, body was: ${error.error}`);
                const msg = this.translate.instant('errors.generalError');
                this.toastService.error(msg, '', 5000);
            }
        }
    }
}